/* eslint-disable */
import colors from '../../../../../public/colors'

export default theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            justifyContent: 'flex-end',
            height: '100%'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            }
        },
        introButtonContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'end',
            gap: '5%',
            width: '100%'
        },
        backButton: {
            '&.MuiButton-root': {
                backgroundColor: colors[mode].insightCardHover,
                border: `1px solid ${colors[mode].cardImageTextAppHover}`,
                boxShadow: 'none',
                color: colors[mode].mfaActiveBackground,
                height: '32px',
                width: 'auto'
            }
        },
        nextButton: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxSizing: 'border-box',
                boxShadow: 'none',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: 'auto'
            }
        },
        setupFooterContainer: {
            justifyContent: 'flex-start !important',
        },
        cardItem: {
            display: 'flex',
            gap: '10px',
            paddingLeft: '10px',
            alignItems: 'center'
        },
        cardItemIcon: {
            width: '24px',
            height: '24px',
            flexShrink: 0,
            objectFit: 'contain'
        },
        cancelButton: {
            '&.MuiButton-root': {
                backgroundColor: colors[mode].primaryBackground,
                boxShadow: 'none',
                color: colors[mode].mfaActiveBackground,
                height: '32px',
                marginLeft: '7px',
                width: 'auto'
            }
        },
        cardsGrid: {
            display: 'grid',
            gridTemplateColumns: 'auto',
            gap: '2px'
        },
        checkCircle: {
            height: '32px',
            width: '32px'
        },
        content: {
            color: '#0267FF',
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            backgroundColor: 'white',
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: 'black'
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            color: 'black',
            fontSize: '20px'
        },
        customLoader: {
            paddingTop: '25%'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        fieldsContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            width: '100%'
        },
        introText: {
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '1%',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '16px',
                paddingRight: theme.spacing(1),
                paddingTop: '16px'
            }
        },
        cardsContainer: {
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '0',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        setupContainer: {
            paddingTop: '2%'
        },
        mfaDesc: {
            color: 'rgba(0,0,0,0.54)',
            fontSize: '14px'
        },
        mfaListContainer: {
            paddingTop: '20px'
        },
        mfaLogo: {
            height: '32px',
            width: '32px'
        },
        mfaLogoContainer: {
            alignItems: 'flex-start',
            display: 'flex'
        },
        mfaSetupTitle: {
            color: 'rgba(0,0,0,0.87)',
            fontSize: '16px',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            paddingTop: '20px',
            marginBottom: '10px'
        },
        mfaTitle: {
            color: 'rgba(0,0,0,0.87)',
            font: 'Roboto',
            fontSize: '16px',
            fontWeight: 500,
        },
        mfaTitleDesc: {
            minHeight: '76px'
        },
        active: {
            justifyContent: 'end !important',
            alignItems: 'center !important',
            paddingTop: '0'
        },
        nextButtonDisabled: {
            '&.MuiButton-root': {
                opacity: '50%'
            }
        },
        selectedCard: {
            backgroundColor: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
        },
        radio: {
            width: '42px',
            height: '42px',
            alignSelf: 'center',
            justifySelf: 'center',
            '&.Mui-checked': {
                color: colors[mode].recoveryIcon
            },
            color: colors[mode].primaryText
        },
        italics: {
            fontStyle: 'italic'
        },
        subTitle: {
            color: colors[mode].cardDescription,
            fontSize: '0.875rem',
            letterSpacing: '0.17px',
            lineHeight: '1.25rem'
        },
        helpText: {
            fontStyle: 'italic',
            margin: 0,
            padding: '2% 0px 24px 25px',
            [theme.breakpoints.down('md')]: {
                padding: '7px 24px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0px 24px 0px 24px',
            }
        },
        setupHelpText: {
            fontStyle: 'italic',
            margin: 0,
            padding: '2% 0px 24px 23px',
            [theme.breakpoints.down('md')]: {
                padding: '7px 20px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0px 24px 0px 24px',
            }
        },
        cardIcon: {

            paddingLeft: '6%',
            paddingTop: '1%'
        },
        accountRecoveryInfo: {
            display: 'grid',
            gridTemplateColumns: '10px auto',
            gap: '15px',
            paddingTop: '2%',
            marginBottom: '1%'
        },
        setUpCard: {
            '&:hover': {
                backgroundColor: colors[mode].skeletonInsightsBackground,
                border: `1px solid ${colors[mode].recoveryBorder}`,
                color: '#003168',
                cursor: 'pointer'
            },
            display: 'grid',
            gridTemplateColumns: '6fr 1fr',
            border: `1px solid ${colors[mode].welcomeCardBorder}`,
            borderRadius: '5px',
            marginLeft: 0,
            marginBottom: '2%',
            width: '100%',
        },
        alreadySelected: {
            border: 'none !important',
            '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'default'
            }
        },
        subCardMargin: {
            justifyContent: 'normal',
            paddingLeft: '28%'
        },
        subCard: {
            background: '#F8F9FB',
            cursor: 'pointer',
            display: 'flex',
            gap: '10px',
            border: '1px solid rgba(0, 49, 104, 0.1)',
            width: '245px',
            justifyContent: 'center',
            alignItems: 'center'
        },
        setupIcon: {
            flexShrink: 0,
            width: '16px',
            height: '16px',
        },
        setupDesc: {
            fontSize: '0.75rem',
            color: colors[mode].cardDescription,
            margin: '0 5% 4% 0',
        },
        imgDesc: {
            fontSize: '1rem',
            color: colors[mode].mfaActiveBackground,
            fontWeight: '500',
            margin: '0 5% 2% 0',
            fontWeight: '500'
        },
        passwordSuccess: {
            width: '24px',
            height: '24px',


            color: theme.palette.success.main

        },
        listItemIcon: {
            justifySelf: 'center',
            alignSelf: 'center'
        },
        setUp: {
            color: colors[mode].mfaActiveBackground,
            fontSize: '0.75rem',
            cursor: 'pointer',
            paddingRight: '10px',
        }

    }
}
